import {gql} from '@apollo/client'

export const GET_PROS_NEARME = gql`
query NearmeDefinition($zipcode: String, $projectType: String, $page: Int, $limit: Int, $site: String) {
    nearmeDefinition(zipcode: $zipcode, projectType: $projectType, page: $page, limit: $limit, site: $site) {
      posts {
        d
        _attributes_id
        n
        ph
        r
        rt
        ur
        pr
        db
      }
      place
      zipcode
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemCount
        pageCount
        perPage
        totalCount
      }
    }
  }
`